var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "circle-selected_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#58AB27;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.647,15.723l-0.157,0.182c-0.003-0.003-44.96,52.182-44.96,52.182c-0.76,0.883-1.866,1.39-3.03,1.39 c-1.193-0.006-2.303-0.526-3.058-1.422L29.004,50.929c-1.377-1.634-2.039-3.707-1.855-5.839c0.18-2.129,1.183-4.058,2.818-5.431 l5.151,6.116c0.003-0.002,11.415,13.534,11.415,13.534l42.052-48.812c1.443-1.671,3.966-1.858,5.639-0.417 C95.897,11.521,96.089,14.049,94.647,15.723z M92.675,35.462l-1.307-4.506l-6.401,6.648C85.67,40.05,85.985,42.131,85.985,48 c0,20.953-17.047,38-38,38s-38-17.047-38-38s17.047-38,38-38c9.213,0,18.236,3.333,25.41,9.386l5.158-6.114 C69.939,6.003,59.083,2,47.985,2c-25.364,0-46,20.636-46,46s20.636,46,46,46s46-20.636,46-46 C93.985,41.919,93.677,38.97,92.675,35.462z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSelected);
export default __webpack_public_path__ + "static/media/circle-selected.9218181570c2fb32aaafb6d88b0bf542.svg";
export { ForwardRef as ReactComponent };